import { NexusFilters, NexusSnapshotsResponse } from "./types";

const FLIGHTS_API_URL =
  process.env.REACT_APP_FLIGHTS_API_URL || "https://api.fleet.aerovect.com";

const BASE_URL =
  process.env.NODE_ENV === "production" ? FLIGHTS_API_URL : "/api";

export async function fetchNexusSnapshots(
  filters: NexusFilters,
  token: string,
  signal?: AbortSignal,
): Promise<NexusSnapshotsResponse> {
  const params = new URLSearchParams({
    airport: filters.airport.trim(),
    hours_back: String(filters.hoursBack),
    hours_forward: String(filters.hoursForward),
  });

  const response = await fetch(`${BASE_URL}/nexus/snapshots?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });

  if (!response.ok) {
    throw new Error(`API error ${response.status}: ${await response.text()}`);
  }
  return response.json();
}
